// extracted by mini-css-extract-plugin
export default {"godroll":"Ix_a_6E_","trashlist":"hoMvUHFR"};